import { Container, Typography, useMediaQuery, useTheme } from "@mui/material";
import React from "react";
import Lottie from "react-lottie";
import dataLottie from "../lotties/sem-pesquisa.json";
import dataLottie2 from "../lotties/pesquisando.json";
import dataLottie3 from "../lotties/desenvolvimento.json";
import dataLottie4 from "../lotties/conclusao.json";
import dataLottie5 from "../lotties/sem_update.json";
import dataLottie6 from "../lotties/indicador-esquerda.json";
import dataLottie7 from "../lotties/aleatorio.json";
import dataLottie8 from "../lotties/cashback.json";

import { Body1 } from "./tipografia";

const defaultOptions = {
  loop: true,
  autoplay: true,
  delay: 2000,
  animationData: dataLottie,
  rendererSettings: {
    preserveAspectRatio: "xMidYMid slice",
  },
};

export const SemPesquisa = ({ titulo }) => {
  const isMobile = useMediaQuery(useTheme()?.breakpoints?.down("md"));

  return (
    <Container disableGutters maxWidth="xs" sx={{ p: 1, mt: 2 }}>
      <Typography variant="body1" align="center">
        {titulo}
      </Typography>
      <Lottie
        options={defaultOptions}
        height={isMobile ? 200 : 400}
        width={isMobile ? 200 : 400}
      />
    </Container>
  );
};

SemPesquisa.defaultProps = {
  titulo: "Defina os dados e clique em pesquisar",
};

export const Pesquisando = () => {
  const isMobile = useMediaQuery(useTheme()?.breakpoints?.down("md"));

  return (
    <Container disableGutters maxWidth="xs" sx={{ p: 1, mt: 2 }}>
      <Lottie
        options={{ ...defaultOptions, animationData: dataLottie2 }}
        height={isMobile ? 200 : 400}
        width={isMobile ? 200 : 400}
      />
    </Container>
  );
};

export const Desenvolvimento = ({ titulo }) => {
  const isMobile = useMediaQuery(useTheme()?.breakpoints?.down("md"));

  return (
    <Container disableGutters maxWidth="xs" sx={{ p: 1, mt: 2 }}>
      <Lottie
        options={{ ...defaultOptions, animationData: dataLottie3 }}
        height={isMobile ? 200 : 400}
        width={isMobile ? 200 : 400}
      />
      <Body1 align="center">{titulo}</Body1>
    </Container>
  );
};

export const Parabens = ({ titulo }) => {
  const isMobile = useMediaQuery(useTheme()?.breakpoints?.down("md"));

  return (
    <Container disableGutters maxWidth="xs" sx={{ p: 1, mt: 2 }}>
      <Lottie
        options={{ ...defaultOptions, animationData: dataLottie4 }}
        height={isMobile ? 200 : 400}
        width={isMobile ? 200 : 400}
      />
      <Body1 align="center">{titulo}</Body1>
    </Container>
  );
};

export const SemDados = ({ titulo, width, height }) => {
  const isMobile = useMediaQuery(useTheme()?.breakpoints?.down("md"));

  return (
    <Container disableGutters maxWidth="xs" sx={{ p: 1, mt: 2 }}>
      <Lottie
        options={{ ...defaultOptions, animationData: dataLottie5 }}
        height={height ? height : isMobile ? 200 : 400}
        width={width ? width : isMobile ? 200 : 400}
      />
      <Body1 align="center">{titulo}</Body1>
    </Container>
  );
};

export const IndicadorEsquerda = ({ titulo, width, height }) => {
  const isMobile = useMediaQuery(useTheme()?.breakpoints?.down("md"));

  return (
    <Container disableGutters maxWidth="xs" sx={{ p: 1, mt: 2 }}>
      <Lottie
        options={{ ...defaultOptions, animationData: dataLottie6 }}
        height={height ? height : isMobile ? 200 : 400}
        width={width ? width : isMobile ? 200 : 400}
      />
      <Body1 align="center">{titulo}</Body1>
    </Container>
  );
};

export const AnimacaoAleatorio = ({ titulo, width, height }) => {
  const isMobile = useMediaQuery(useTheme()?.breakpoints?.down("md"));

  return (
    <Container disableGutters maxWidth="xs" sx={{ p: 1, mt: 2 }}>
      <Lottie
        options={{ ...defaultOptions, animationData: dataLottie7 }}
        height={height ? height : isMobile ? 200 : 400}
        width={width ? width : isMobile ? 200 : 400}
      />
      <Body1 align="center">{titulo}</Body1>
    </Container>
  );
};

export const AnimacaoCashback = ({ titulo, width, height }) => {
  const isMobile = useMediaQuery(useTheme()?.breakpoints?.down("md"));

  return (
    <Container disableGutters maxWidth="xs" sx={{ p: 1, mt: 2 }}>
      <Lottie
        options={{ ...defaultOptions, loop: false, animationData: dataLottie8 }}
        height={height ? height : isMobile ? 200 : 400}
        width={width ? width : isMobile ? 200 : 400}
      />
      <Body1 align="center">{titulo}</Body1>
    </Container>
  );
};

Desenvolvimento.defaultProps = {
  titulo: "Página ainda em desenvolvimento...",
};

//export default SemPesquisa
